import { Link } from 'react-router-dom';

const FRIEND_LINKS = [
  { label: '电视剧频道', to: '/category/tv' },
  { label: '电影频道', to: '/category/movie' },
  { label: '热门推荐', to: '/' },
  { label: '关于我们', to: '/about' },
];

const DISCOVER_LINKS = [
  { label: '悬疑剧集', to: '/category/tv' },
  { label: '科幻电影', to: '/category/movie' },
  { label: '都市情感', to: '/category/tv' },
  { label: '全球热映', to: '/category/movie' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-secondary-950 text-background-200">
      <div className="px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center text-xl">
                <i className="ri-film-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">年轻的岳母</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              专注高清电视剧与电影的剧情、演员与作品资料展示，为影视爱好者提供清晰、专业、便捷的内容浏览体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4 tracking-wide">导航</h3>
            <ul className="space-y-2.5">
              {FRIEND_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4 tracking-wide">发现</h3>
            <ul className="space-y-2.5">
              {DISCOVER_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50 mb-4 tracking-wide">联系我们</h3>
            <ul className="space-y-3 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
                contact@ylws-cinema.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-400" aria-hidden="true"></i>
                微信公众号：年轻的岳母影视
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-accent-400" aria-hidden="true"></i>
                微博：@年轻的岳母
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2026 年轻的岳母 · 高清影视资料展示平台 · 本站为前端演示站点</p>
          <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <span>内容仅供学习交流</span>
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              免责声明
            </Link>
            <Link to="/about" className="hover:text-accent-400 transition-colors">
              版权声明
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}